import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getBaseUrl } from '../../config/api';
import { WEB_APP_ORIGIN } from '../storeConfig';
import DeepLinkShell from '../DeepLinkShell';
import SmartAppCta from '../SmartAppCta';

const BookingLanderPage: React.FC = () => {
  const { shortCode: stylistId } = useParams<{ shortCode: string }>();
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get('serviceId');
  const [name, setName] = useState('this stylist');

  useEffect(() => {
    if (!stylistId) return;
    fetch(`${getBaseUrl()}/profile/stylists/${encodeURIComponent(stylistId)}`)
      .then((r) => r.json())
      .then((data) => {
        const s = data.data || data;
        if (s?.name || s?.businessName) setName(s.name || s.businessName);
      })
      .catch(() => undefined);
  }, [stylistId]);

  const webRedirect = `/client/stylist/${stylistId}${serviceId ? `?serviceId=${serviceId}` : ''}`;

  return (
    <DeepLinkShell>
      <div className="dl-card">
        <h1 className="dl-name">Book with {name}</h1>
        <p className="dl-meta">
          Continue in the LookBel app to pick a time
          {serviceId ? ' for this service' : ''} and complete your booking.
        </p>
        <SmartAppCta
          title="Open LookBel to book"
          subtitle="If you don’t have the app yet, download it below — then search for this stylist."
          webHref={`${WEB_APP_ORIGIN}/login?redirectTo=${encodeURIComponent(webRedirect)}`}
          webLabel="Sign in to book on the web"
        />
      </div>
    </DeepLinkShell>
  );
};

export default BookingLanderPage;
